<template>
  <div class="search-bar">
    <input 
      v-model="searchQuery"
      @input="$emit('search', searchQuery)"
      type="text" 
      placeholder="Search devices by name, ID, or model..."
      class="search-input"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { COLORS } from '@/styles/brand'

const props = defineProps({
  searchValue: {
    type: String,
    default: ''
  }
})

const searchQuery = ref(props.searchValue)

defineEmits(['search'])

// Watch for external search value changes
watch(() => props.searchValue, (newValue) => {
  searchQuery.value = newValue
}, { immediate: true })
</script>

<style scoped>
.search-bar {
  width: 400px;
  min-width: 400px;
}

.search-input {
  width: 100%;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  color: white;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.search-input:focus {
  border-color: v-bind('COLORS.PRIMARY.RED');
  box-shadow: 0 0 20px v-bind('COLORS.PRIMARY.RED + "40"');
  background: rgba(255, 255, 255, 0.15);
}
</style>